import React, { useState, useRef, FC } from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components/macro';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { useJsApiLoader } from '@react-google-maps/api';

import Error from './components/Error';
import { Search } from './components/Search';
import LocationContext, { Coords, Filters } from './components/Context';

const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || `${window.location.origin}/graphql`,
    cache: new InMemoryCache(),
});

const theme = {
    colors: {
        brand: '#046a38',
        alt: '#009fe3',
        copy: '#222222',
        dark: '#222222',
        grey: '#E7E7E7',
        lightGrey: '#EEEEEE',
        white: '#fff',
    },
    typography: {
        fontFamily: `'Veneer', sans-serif`,
        base: '14px',
        heading: {
            sm: '36px',
            lg: '36px',
        },
        subHeading: {
            sm: '24px',
            lg: '32px',
        },
        tagline: {
            sm: '16px',
            lg: '18px',
        },
    },
    breakpoints: {
        sm: 768,
        lg: 992,
    },
    space: {
        sm: '24px',
        lg: '48px',
    },
};

const GlobalStyle = createGlobalStyle`
body {
  margin: 0;
  * {
    box-sizing: border-box;
  }


}

[data-reach-dialog-overlay] {
    z-index: 101;
    background-color: rgba(0, 0, 0, 0.8);
}
.stockist-widget {
    line-height: normal;
    margin-bottom: 24px;
    max-width: calc(100vw - 20px);

    @media(min-width: 768px) {
        max-width: 100%;
    }

   font-family: Arial, sans-serif;
   color: #222;
    pre,code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a {
    color: #222;
}

}

`;

interface AppProps {
    brand?: any;
    product?: any;
    basic?: any;
    layout?: any;
}
// Base url user for router
const App: FC<AppProps> = ({ brand, product, basic = false, layout = 'vert' }) => {
    // User selected Lat lng
    const [selectedLatLng, setSelectedLatLng] = useState<Coords>();
    // User selected filters
    const [filters, setFilters] = useState<Filters>({});
    // The selected location in words e.g Brighton
    const [selectedDescription, setSelectedDescription] = useState<string>();
    // The Type of Search performed
    const [searchType, setSearchType] = useState<'GEO' | 'SEARCHED' | 'AREA' | 'DEFAULT'>('DEFAULT');

    // The libraries needed for Google maps
    // Ref to stop rerender
    const libraries = useRef<any[]>(['places']);

    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyBhMVzPI9COJqvjm2sAMXzHmECzEsfosZ4', // production
        // googleMapsApiKey: 'AIzaSyDyeijbb0LdUOTcfV-zCC_prpeoP73_t64', // local    
        libraries: libraries.current,
    });

    console.log({ layout });
    return (
        <ApolloProvider client={client}>
            <ThemeProvider theme={theme}>
                <LocationContext.Provider
                    value={{
                        selectedLatLng,
                        setSelectedLatLng,
                        selectedDescription,
                        setSelectedDescription,
                        searchType,
                        setSearchType,
                        filters,
                        setFilters,
                        brand,
                        product,
                        basic,
                        layout,
                    }}
                >
                    <GlobalStyle />

                    <div className="stockist-widget">
                        {loadError && <Error error="Error Loading Search" />}
                        {isLoaded && !loadError && <Search />}
                    </div>
                </LocationContext.Provider>
            </ThemeProvider>
        </ApolloProvider>
    );
};

export default App;
